// extracted by mini-css-extract-plugin
export default {"message":"ConfirmPopup_message__iGyt6","centered":"ConfirmPopup_centered__LUEmr"};